module.exports = __webpack_public_path__ + "static/media/signage-indoor-img56.47216922.jpg";